import axios from 'axios';

const baseURL = process.env.CONTENT_ENGINE_URL;
const clientBaseUrl = `${baseURL}/app/client`;

const client = {
    // GET /app/client
    async getClient() {
        return axios.get(clientBaseUrl);
    },

    // GET /app/client/app
    async getSubscribedCEApps(id) {
        return axios.get(`${clientBaseUrl}/app`);
    },

    // GET /ce-admin/client/unpublished
    async getAllAppliedUpdates() {
        return axios.get(`${clientBaseUrl}/unpublished`);
    },

    // GET /app/client/published/complispace
    async getAllComplispaceUpdates() {
        return axios.get(`${clientBaseUrl}/published/complispace`);
    },

    // GET /app/client/parent
    async getClientParent() {
        return axios.get(`${clientBaseUrl}/parent`);
    },

    // GET /app/client/children
    async getClientChildren() {
        return axios.get(`${clientBaseUrl}/children`);
    },

    async notify() {
        return axios.post(`${clientBaseUrl}/notify`);
    }
};

export default client;



// WEBPACK FOOTER //
// ./src/api/client.js